export const IndicatorsCard = ({ number, title, icon }) => {
  return (
    <div className="card shadow-md">
      <div className="card-body d-flex align-items-center gap-3">
        <div className="vstack gap-2">
          <h4 className="mb-0">{number}</h4>
          <span className="mb-0">{title}</span>
        </div>
        <div className="flex-shrink-0">
          <div className="btn btn-icon btn-secondary">{icon}</div>
        </div>
      </div>
    </div>
  );
};
